module.exports = __webpack_public_path__ + "img/wheel_logo.51a410be.png";